require('angular-material');
require('./dist/md-time-picker');

module.exports = 'md.time.picker';
